import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useState } from "react";
import { useMemo } from "react";
import { postProductionFGReceipt } from "../../../APIServices/ProductionService/ProductionFgService/ProductionFgThunk";
import CommonDialog from "../../../SharedFiles/CommonModal/CommonDialog";
import {
  convertCase,
  validateDecimalInput,
  validateFormData,
  validateInteger,
} from "../../../SharedFiles/Helper/utils";
import DynamicTable from "../../../SharedFiles/CommonTable/dynamicTable";
import { toast, Toaster } from "react-hot-toast";
import { showSubmitConfirmation } from "../../../SharedFiles/WarningMessage/deleteWarning";
import { useTranslation } from "react-i18next";
import "./ProductionFg.css";

const ProductionFgPost = ({
  selectedbatch,
  setInProgress,
  setGetValues,
  getValues,
  selectedAllbatch,
  setOpenAddBatch,
  openAddBatch,
  tableBody,
}) => {
  
  const { PRODReceipt, ProdTransList } = useSelector(
    (state) => state.ProductionFg
  );
  const header = ["item_Code", "item_Name", "batch_Number", "quantity"];
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [InFgProgress, setInFgProgress] = useState({
    INVPINPUTCall: false,
    PorReceiptCall: false,
  });
  const [inputField, setInputField] = useState([]);
  const [searchData, setSearchData] = useState([]);
  const [ReceiptTypeDrop, setReceiptTypeDrop] = useState([]);
  const [selectedItem, setSelectedItem] = useState([]);
  const [errorMessage, setErrorMessage] = useState({});
  const [disabledFields, setDisabledFields] = useState([]);
  const [receiptItem, setReceiptItem] = useState({
    item_Code: "",
    item_Name: "",
    quantity_Nos: "",
    Receipt_Type: "",
    batch_Number: "",
    warehouse: "",
    Weight: 0,
    remarks: "",
  });

  const receiptWarehouseMap = {
    BUNDLE: "FG",
    "LOOSE BAR": "LOOSE B",
    "WHITE PATCH": "WPE01",
    "BLACK PATCH": "B-PATCH",
    "NO PRINT": "NP",
    "COATING DMG": "COAT-D",
    "DAMAGE BAR": "DMG",
    NONWELDBARS: "NON WELD",
    // 'WELDED BAR WH': 'WELDED',
    // 'RUSTED BARS WH': 'RUSTED',
    // 'NOT FUNCTIONING': 'INACTIVE',
  };
  const fgReceiptTypeDrop = [
    { B: "BUNDLE" },
    { LB: "LOOSE BAR" },
    { WP: "WHITE PATCH" },
    { BP: "BLACK PATCH" },
    { NP: "NO PRINT" },
    { CD: "COATING DMG" },
    { DMG: "DAMAGE BAR" },
    { NWB: "NONWELDBARS" },
    //  {'WB':'WELDED BAR'}
    // { 'WB':'WELDED BAR'},
    // { 'R': 'RUSTED BARS WH' },
    // { 'INA': 'NOT FUNCTIONING' },
  ];

  const ModelField = useMemo(() => {
    return PRODReceipt?.length > 0
      ? Object.keys(PRODReceipt[0])
          .filter(
            (header) =>
              header !== "docEntry" &&
              header !== "order_Num" &&
              header !== "iWeight" &&
              header !== "baseLine" &&
              header !== "quantity_Nos" &&
              header !== "warehouse"
          )
          .concat(
            "Receipt_Type",
            "quantity_Nos",
            "Weight",
            "warehouse",
            "remarks"
          ) // Manually add 'batch_number' to the end
      : [];
  }, [PRODReceipt]);

  const tableHeader = [
    "item_Code",
    "item_Name",
    "batch_Number",
    "qty_Nos",
    "receipt_Type",
    "weight",
    "wareHouse",
  ];

 
  
  const handleIpClick = () => {};
  const generateBatchNo = async (fetchedItem, value) => {
    let receiptTypeCode;
    if (value === "WELDED BAR") {
      receiptTypeCode = "WB";
    } else {
      const matchedItem = fgReceiptTypeDrop.find(
        (item) => Object.values(item)[0] === value
      );
      receiptTypeCode = matchedItem ? Object.keys(matchedItem)[0] : "";
    }
    const currentDate = new Date();
    const day = String(currentDate.getDate()).padStart(2, "0");
    const month = String(currentDate.getMonth() + 1).padStart(2, "0");
    const currentYear = currentDate.getFullYear();
    const yearAlphabet = String.fromCharCode(65 + (currentYear - 2025));
    const hours = String(currentDate.getHours()).padStart(2, "0");
    const minutes = String(currentDate.getMinutes()).padStart(2, "0");
    const seconds = String(currentDate.getSeconds()).padStart(2, "0");
    const formattedDate = `${day}${month}${yearAlphabet}${hours}${minutes}${seconds}`;
    const batchNo = `${receiptTypeCode}${fetchedItem.order_Num}${formattedDate}`;
    return batchNo;
  };

  const handleAddBatch = () => {
    setDisabledFields([
      "Receipt_Type",
      "quantity_Nos",
      "Weight",
      "batch_Number",
      "warehouse",
    ]);
    setOpenAddBatch(true);
    setSearchData(PRODReceipt);
    setGetValues(receiptItem);
    setInputField(["item_Code", "item_Name"]);
    setInFgProgress((prev) => ({
      ...prev,
      PorReceiptCall: true,
    }));
  };
  const handleCloseDialog = () => {
    setOpenAddBatch(false);
    setErrorMessage({});
  };

  const handleValueChange = async (e, header) => {
    if (!selectedItem) return; // Guard clause
    const itemCode = selectedItem.item_Code;
    const inputValue = e.target.value;
    setErrorMessage({});
    const {
      isValid,
      values: cleanedValue,
      error,
    } = validateDecimalInput(inputValue);
    if (header === "Receipt_Type") {
      const warehouse = receiptWarehouseMap[inputValue] || "FG";
      // Update disabled fields based on Receipt Type
      setDisabledFields(
        inputValue !== "BUNDLE"
          ? ["batch_Number", "warehouse"]
          : ["quantity_Nos", "batch_Number", "warehouse"]
      );
      setGetValues((prevState) => ({
        ...prevState,
        quantity_Nos: selectedItem.quantity_Nos,
        warehouse: warehouse,
        [header]: inputValue,
      }));

      // Only generate batch number if itemCode is not Scrap
      if (itemCode !== "SCRAP BAR" && itemCode !== "Scrap") {
        const batch = await generateBatchNo(selectedItem, inputValue);
        setGetValues((prevState) => ({
          ...prevState,
          batch_Number: batch,
        }));
      }
    } else if (header === "Weight") {
      setGetValues((prevState) => ({
        ...prevState,
        [header]: isValid ? cleanedValue : cleanedValue,
      }));
    } else if (
      header === "quantity_Nos" &&
      getValues.Receipt_Type !== "BUNDLE"
    ) {
      if (inputValue === "" || validateInteger(inputValue)) {
        setGetValues((prevState) => ({
          ...prevState,
          [header]: inputValue,
        }));
      }
    } else if (header === "remarks") {
      setGetValues((prevState) => ({
        ...prevState,
        [header]: inputValue,
      }));
    }

    // Generate batch for other changes if itemCode is not Scrap
    if (
      header !== "Receipt_Type" &&
      itemCode !== "SCRAP BAR" &&
      itemCode !== "Scrap"
    ) {
      const batchType =
        itemCode === "WELDED BAR" ? "WELDED BAR" : getValues.Receipt_Type;
      const batch = await generateBatchNo(selectedItem, batchType);
      setGetValues((prevState) => ({
        ...prevState,
        batch_Number: batch,
      }));
    }
  };
  const handleSearchDrop = async (item, fieldname) => {
    setErrorMessage({});
    setSelectedItem(item);
    setGetValues((prevValues) => ({
      ...prevValues,
      item_Code: "",
      item_Name: "",
      quantity_Nos: "",
      Receipt_Type: "",
      batch_Number: "",
      warehouse: "",
    }));
    if (item.warehouse === "FG") {
      setDisabledFields(["quantity_Nos", "batch_Number", "warehouse"]);
      setReceiptTypeDrop(fgReceiptTypeDrop);
    } else {
      setDisabledFields([
        "Receipt_Type",
        "quantity_Nos",
        "batch_Number",
        "warehouse",
      ]);
      setReceiptTypeDrop([]);
    }
    setGetValues((prevValues) => ({
      ...prevValues,
      ...item,
      // batch_Number: batchNo
    }));
  };
  
  const handleSubmit = async (e) => {
    setOpenAddBatch(true);
    const validationRules = [
      { field: "item_Code", validationTypes: ["exists", "required"] },
      { field: "item_Name", validationTypes: ["exists", "required"] },
      { field: "Weight", validationTypes: ["required"] },
      // { field: 'Receipt_Type', validationTypes: ['required'] },
    ];
    const itemCode = getValues.item_Code;
    const quantityNos = getValues.quantity_Nos;

    if (InFgProgress.PorReceiptCall) {
      if (
        itemCode !== "WELDED BAR" &&
        itemCode !== "SCRAP BAR" &&
        itemCode !== "Scrap" &&
       (quantityNos === "0" ||
        quantityNos === "")
      ) {
        validationRules.push(
          { field: "quantity_Nos", validationTypes: ["required"] } 
        );
      }
      if (
        itemCode !== "WELDED BAR" &&
        itemCode !== "SCRAP BAR" &&
        itemCode !== "Scrap")
        {
          validationRules.push(
            { field: "Receipt_Type", validationTypes: ["required"] }
          );
        }

        const skipTypes = ["WELDED BAR", "SCRAP BAR", "Scrap"];

        if (skipTypes.includes(itemCode)) {
          if (selectedbatch.quantity < parseFloat(getValues.Weight)) {
            toast.error(
              `Weight must not be greater than planned Quantity - ${selectedbatch.quantity}`
            );
            setOpenAddBatch(true);
            return;
          }
        }
    }
    let newErrorMessage = {};
    newErrorMessage = validateFormData(validationRules, PRODReceipt, getValues);
    if (Object.keys(newErrorMessage).length > 0) {
      setErrorMessage(newErrorMessage);
      setOpenAddBatch(true);
      return;
    }
    const tolerance = Math.round(
      selectedItem.iWeight * parseInt(getValues.quantity_Nos)
    );
    const weight = parseFloat(getValues.Weight);
    const quantity = parseFloat(getValues.quantity_Nos);
    if (weight < tolerance - 20 || weight > tolerance + 20) {
      toast.error(
        `Weight must be within ±20 of the tolerance value (${tolerance}).`
      );
      setOpenAddBatch(true);
      return;
    }
    // setErrorMessage({});
    showSubmitConfirmation(() => {
      if (!getValues) {
        toast.error(t("Add a receipt before submitting"));
        return;
      }
      let issuesProduction = [];
      let currentBatchIndex = 0;
      let remainingWeight =getValues.Weight;
      for (const batch of selectedAllbatch) {
        if (remainingWeight <= 0) break; // No more weight to allocate
        // Get the batch's available quantity (which is the maximum weight it can handle)
        const batchQuantity = batch.quantity;
        // Determine how much weight to assign to this batch
        let weightToAssign = 0;
        if (remainingWeight <= batchQuantity) {
          weightToAssign = remainingWeight; // All remaining weight fits into this batch
          remainingWeight = 0; // No more weight to allocate
        } else {
          weightToAssign = batchQuantity; // Use the full capacity of this batch
          remainingWeight -= batchQuantity; // Subtract the allocated weight
        }
        issuesProduction.push({
          prodNum: batch.pur_Num,
          issuesRemarks: getValues.remarks, // Customize this as needed
          issuesQuantity: weightToAssign,
          batchNum: batch.batch_Number,
          batchQty: weightToAssign,
          rowId: batch.baseLine,
        });

        currentBatchIndex++;
      }
      const goodReceipt = [
        {
          ItemCode: getValues.item_Code,
          ProdEntry: getValues.docEntry,
          Quantity: getValues.Weight,
          WhsCode: getValues.warehouse,
          baseLine: getValues.baseLine,
          Price : selectedbatch.price,
          postBatchs: [
            {
              ReceiptQty: getValues.quantity_Nos || "",
              ReceiptType: getValues.Receipt_Type,
              WhsCode: getValues.warehouse,
              batchNum: getValues.batch_Number,
              batchQty: getValues.Weight,
            },
          ],
          remarks: getValues.remarks,
          quantity_Nos: 0,
        },
      ];

      // Build batchData array
      const currentDate = new Date().toLocaleDateString();
      const batchData = [
        {
          batchNumber: getValues.batch_Number,
          batchDetails: JSON.stringify({
            BatchNumber: getValues.batch_Number,
            PONumber: getValues.order_Num,
            docEntry: getValues.docEntry,
            Itemcode: getValues.item_Code,
            itemName: getValues.item_Name,
            ActualWt: `${getValues.Weight}, Qty - ${getValues.quantity_Nos}`,
            CreatedDate: currentDate,
          }),
          itemName: getValues.item_Name,
          itemCode: getValues.item_Code,
        },
      ];

      // Final payload matching Swagger schema
      const postData = [{
        issuesProduction,
        goodReceipt,
        batchData,
      }];

      dispatch(postProductionFGReceipt(postData));
      setInProgress((prev) => ({ ...prev, ProdReceiptCall: true }));
    });
  };

  return (
    <div className="secondayMain">
      <div>
        <CommonDialog
          openDialog={openAddBatch}
          inputField={inputField}
          openManual={"true"}
          pageName={"ProductionFgissue"}
          handleCloseDialog={handleCloseDialog}
          setGetValues={setGetValues}
          getValues={getValues}
          ReceiptTypeDrop={ReceiptTypeDrop}
          SearchData={searchData}
          handleSearchDrop={handleSearchDrop}
          handleIpClick={handleIpClick}
          InProgress={InFgProgress}
          inputHeader={ModelField}
          errorMessage={errorMessage}
          disabledFields={disabledFields}
          handleValueChange={handleValueChange}
          handleAddDialog={handleSubmit}
        />
      </div>
      <div className="receipt-main">
        {header &&
          header.map((item, index) => (
            <div key={index} className="d-flex gap-0 col-12 col-xl-3">
              <div className="receipt-header-div col-sm-6 col-lg-4 ">
                <p>{t(convertCase(item))} :</p>
              </div>

              <div className="receipt-detail-div col-sm-6 col-lg-4">
                <p>{selectedbatch[item]}</p>
              </div>
            </div>
          ))}

        <div className="receipt-table">
          <button className="button xs mb-1" onClick={handleAddBatch}>
            {t("Add Batch")}
          </button>
          <div className="tableMin">
            <DynamicTable
              header={tableHeader}
              tablebody={ProdTransList}
              pageName={"productionfg"}
            />
          </div>
        </div>
      </div>
      {/* <div className="submit-button-container">
      <button className="button xs" onClick={handleSubmit}>
            {t("Submit")}
          </button> */}
        {/* {tableBody.length > 0 && (
          <button className="button xs" onClick={handleSubmit}>
            {t("Submit")}
          </button>
        )} */}
      {/* </div> */}
      <Toaster
        position="top-center"
        toastOptions={{
          style: {
            fontSize: "16px",
            padding: "16px",
            width: "400px",
            borderRadius: "8px",
          },
        }}
      />
    </div>
  );
};

export default ProductionFgPost;
